export type SubscriptionState = {
  email?: string;
  subscribedAt: string;
  verified?: boolean;
};

const KEY = 'emailSubscribed';

export function isSubscribed(): boolean {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return false;
    const obj = JSON.parse(raw) as SubscriptionState;
    return !!obj && !!obj.subscribedAt;
  } catch {
    return false;
  }
}

export function markSubscribed(email?: string) {
  const state: SubscriptionState = {
    email,
    subscribedAt: new Date().toISOString(),
    verified: false,
  };
  localStorage.setItem(KEY, JSON.stringify(state));
}

export function markVerified() {
  try {
    const raw = localStorage.getItem(KEY);
    const base: SubscriptionState = raw ? JSON.parse(raw) : { subscribedAt: new Date().toISOString() };
    base.verified = true;
    localStorage.setItem(KEY, JSON.stringify(base));
  } catch {
    const state: SubscriptionState = { subscribedAt: new Date().toISOString(), verified: true };
    localStorage.setItem(KEY, JSON.stringify(state));
  }
}

export function clearSubscriptionFlag() {
  localStorage.removeItem(KEY);
}

